import { createSlice } from "@reduxjs/toolkit";
import {
  fetchClassesThunk,
  fetchSubjectsByClassThunk,
} from "../../chapter/redux/chapterThunk";

const initialState = {
  classes: [],
  subjects: [],
  selectedClassId: "",
  selectedSubjectId: "",
  selectedYear: "",
  questionPapers: [],
  loadingClasses: false,
  loadingSubjects: false,
};

const samplePaperSlice = createSlice({
  name: "sample paper",
  initialState,
  reducers: {
    setSelectedClassId: (state, action) => {
      state.selectedClassId = action.payload;
    },
    setSelectedSubjectId: (state, action) => {
      state.selectedSubjectId = action.payload;
    },
    // setSelectedSectionId: (state, action) => {
    //   state.selectedSectionId = action.payload;
    // },
    // setSelectedChapterId: (state, action) => {
    //   state.selectedChapterId = action.payload;
    // },
    // setChapterName: (state, action) => {
    //   state.chapterName = action.payload;
    // },
    // setEditingChapter: (state, action) => {
    //   state.editingChapter = action.payload;
    // },
    setSubjects: (state, action) => {
      state.subjects = action.payload;
    },
    setSections: (state, action) => {
      state.sections = action.payload;
    },
    // setChapters: (state, action) => {
    //   state.chapters = action.payload;
    // },
    setClasses: (state, action) => {
      state.classes = action.payload;
    },
    setSelectedYear: (state, action) => {
      state.selectedYear = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchClassesThunk.pending, (state) => {
        state.loadingClasses = true;
      })
      .addCase(fetchClassesThunk.fulfilled, (state, action) => {
        state.classes = action.payload;
        state.loadingClasses = false;
      })
      .addCase(fetchClassesThunk.rejected, (state) => {
        state.loadingClasses = false;
      })

      // Fetch Subjects
      .addCase(fetchSubjectsByClassThunk.pending, (state) => {
        state.loadingSubjects = true;
      })
      .addCase(fetchSubjectsByClassThunk.fulfilled, (state, action) => {
        state.subjects = action.payload;
        state.loadingSubjects = false;
      })
      .addCase(fetchSubjectsByClassThunk.rejected, (state) => {
        state.loadingSubjects = false;
      });
  },
});

export const {
  setSelectedClassId,
  setSelectedSubjectId,
  setSubjects,
  setClasses,
  setSelectedYear,
} = samplePaperSlice.actions;

export default samplePaperSlice.reducer;
